import Phaser from 'phaser';
import gameData from '../gameData';
import ABCyaPhaser from '@abcya/abcya_phaser';
import GameBackground from '../game/GameBackground';
import SelectScreen from './SelectScreen';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    GameBackground.instance.switchBg('title', true);

    const titleName = gameData.gameConfigs[gameData.game].DIFFICULTY === 'easy' ? 'title-clip-jr' : 'title-clip';
    this.title = ABCyaPhaser.Images.addImage(0, 0, titleName, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS);
    this.title.x = this.scale.width / 2;
    this.title.y = - (this.title.getBounds().height + 100);
    this.title.endY = (this.title.getBounds().height / 2) + 100;

    this.goBtn = ABCyaPhaser.Images.addImage(0, 0, 'btn-play', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.endIntro())
      .setScale(0)
      .setAlpha(0);
    this.goBtn.x = this.scale.width / 2;
    this.goBtn.y = this.title.endY + (this.title.height / 2) + (this.goBtn.height / 2) + 50;

    this.startIntro();
  }

  startIntro () {
    const titleSoundName = gameData.gameConfigs[gameData.game].GAME_TITLE === 'Take a Trip' ? 'title-in' : 'dialog-in';
    this.titleSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, gameData.gameModeSoundAtlas);
    ABCyaPhaser.Audio.playSound(titleSoundName, this.titleSound);

    ABCyaPhaser.Tweens.addTween(this.title, 1500, { delay: 500, y: this.title.endY, easeParams: [1,0.3] }, Phaser.Math.Easing.Elastic.Out);

    this.time.delayedCall(1500, () => {this.introReady();});
  };

  introReady () {
    ABCyaPhaser.Tweens.addTween(this.goBtn, 500, { alpha: 1, scale: 1, easeParams: [1,0.3] }, Phaser.Math.Easing.Elastic.Out);
    this.goBtn.setInteractive();
  };

  endIntro () {
    if (this.titleSound) {
      this.titleSound.stop();
      this.titleSound.destroy();
      this.titleSound = null;
    }

    let delay = 100;
    if (gameData.gameConfigs[gameData.game].GAME_TITLE === 'Take a Trip') {
      ABCyaPhaser.Audio.playOneShot('beep', this, 1, false, 0, gameData.gameModeSoundAtlas);
      delay = 500;
    }

    this.time.delayedCall(delay, () => {this.cleanUp();});
  };

  cleanUp () {
    this.scene.start(SelectScreen.KEY);
  };
}